import {
  
  FormDateRangePicker,
  FormSelect,
  Loader,
} from "@/components";
import useFilter from "./useFilter";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import { X } from "lucide-react";
import { FC } from "react";
import { FilterProps } from "./types";
import {
  APPROVED_BY,
  GL_ACCOUNT,
  PAYMENT_DATE_RANGE,
  POSTED_DATE_RANGE,
} from "../consts";

const Filter: FC<FilterProps> = ({ onCancel, filterData, setFilterData }) => {
  const {
    form,
    onSubmit,
    isMobile,
    onClear,
    isVendorLoading,
    glMasterListing,
    vendorList
  } = useFilter({
    filterData,
    setFilterData,
    onCancel,
  });

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">Filter</DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        {isVendorLoading ? (
          <Loader />
        ) : (
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="relative">
              <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[130px] px-1">
                <div className="grid grid-cols-1 gap-[25px]">
                  <FormSelect
                    name={GL_ACCOUNT}
                    control={form.control}
                    label="GL Entry"
                    placeholder="Please select"
                    multiSelect
                    options={(glMasterListing?.data || [])
                      .filter((data: any) => data?.accountCategory != "I")
                      ?.sort((a: any, b: any) =>
                        a.glAccountNumber?.localeCompare(b.glAccountNumber)
                      )
                      ?.map((data: any) => {
                        return {
                          label: `${data?.glAccountNumber} - ${data?.accountShortDesc}`,
                          value: data?.glMasterId?.toString(),
                        };
                      })
                      ?.sort((a: any, b: any) => {
                        return a.disabled === b.disabled
                          ? 0
                          : a.disabled
                          ? 1
                          : -1;
                      })}
                  />
                  <FormDateRangePicker
                    name={POSTED_DATE_RANGE}
                    control={form.control}
                    label="Posted Date Range"
                    placeholder="Please enter"
                  />
                  <FormDateRangePicker
                    name={PAYMENT_DATE_RANGE}
                    control={form.control}
                    label="Payment Date Range"
                    placeholder="Please enter"
                  />
                  <FormSelect
                    name={APPROVED_BY}
                    control={form.control}
                    label="Created By"
                    placeholder="Please enter"
                    options={vendorList?.data?.map((data: any) => ({label: data?.vendorName?.toString(), value: data?.vendorId?.toString()}))}
                  />
                </div>
              </div>
              <div className="flex flex-row gap-3 absolute bottom-3 w-full bg-white pb-[25px] z-[3] justify-end">
                <Button variant="secondary" type="button" onClick={onClear}>
                  Clear All
                </Button>
                <Button type="submit">Apply Filter</Button>
              </div>
            </form>
          </FormProvider>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default Filter;
